import { render, staticRenderFns } from "./DetailCompanyView.vue?vue&type=template&id=b96661dc&scoped=true&"
import script from "./DetailCompanyView.vue?vue&type=script&lang=js&"
export * from "./DetailCompanyView.vue?vue&type=script&lang=js&"
import style0 from "./DetailCompanyView.vue?vue&type=style&index=0&id=b96661dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96661dc",
  null
  
)

export default component.exports